import DatePicker, { DatePickerProps } from '@/components/DatePickers/DatePicker';

import styles from './DatePickerWrapper.module.scss';

const DatePickerWrapper = (props: DatePickerProps) => {
  return (
    <DatePicker
      {...props}
      styles={{
        input: styles.input,
        label: styles.label
      }}
    />
  );
};

export default DatePickerWrapper;
